<template>
  <div class="tag">
    <div class="tag-name">{{ tag.name }}</div>
    <div class="tag-actions">
      <q-btn
        size="sm"
        color="grey-7"
        style="margin-right:5px"
        round
        @click="
          remove = true;
          selectedTag = tag;
        "
      >
        <q-tooltip>Delete '{{ tag.name }}'</q-tooltip>
        <q-icon
          color="grey-3"
          name="fas fa-trash"
          size="15px"
          class="cursor-pointer"
        ></q-icon>
      </q-btn>
      <q-btn
        size="sm"
        color="grey-7"
        round
        @click="
          edit = true;
          selectedTag = tag;
        "
      >
        <q-tooltip>Edit '{{ tag.name }}'</q-tooltip>
        <q-icon
          color="grey-3"
          name="far fa-edit"
          size="15px"
          class="cursor-pointer"
        ></q-icon>
      </q-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tag: {
      required: false,
      type: Object,
    },
  },
  computed: {
    selectedTag: {
      get() {
        return this.$store.state.tag.selectedTag;
      },
      set(val) {
        this.$store.commit("tag/SET_SELECTED_TAG", val);
      },
    },
    edit: {
      get() {
        return this.$store.state.tag.edit;
      },
      set(val) {
        this.$store.commit("tag/SET_EDIT", val);
      },
    },
    remove: {
      get() {
        return this.$store.state.tag.remove;
      },
      set(val) {
        this.$store.commit("tag/SET_REMOVE", val);
      },
    },
  },
};
</script>

<style lang="scss">
.tag {
  display: flex;
  flex-flow: row nowrap;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  flex: 1;
  align-items: center;
  .tag-name {
    flex: 1;
    font-weight: 500;
  }
  .tag-actions {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    &:first-child {
      button {
        margin-right: 5px;
      }
    }
  }
}
</style>
